export default __webpack_public_path__ + "static/media/BG-DarkBlue-0004.63dc3139.png";